import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const formulariFormDatiTrasporto : AnaColumn[]= [

    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', caption: 'Dati Autista', colCount: "1", data: [
  
  
        { type: 'campo', colVisible: false, dataField: 'idTrasportatore', dataType: "", hideOnEdit: true, colSpan: '2' },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteNome', dataType: "", hideOnEdit: false, caption: "Nome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
        },
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteCognome', dataType: "", hideOnEdit: false, caption: "Cognome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
        },
      ]
    },
    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', caption: 'Dati Veiolo', colCount: "1", data: [
  
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaAutomezzo', dataType: "", hideOnEdit: false, caption: "Targa Automezzo",
          width: 17 * aspect,
          maxLength: "7",
          maxSize: 7,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaRimorchio', dataType: "",
          hideOnEdit: false, caption: "Targa Rimorchio",
          width: 17 * aspect,
          maxLength: "7",
          maxSize: 7,
        },
      ]
    },
    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', caption: 'Data e Ora Della Partenza', data: [
        {
          type: 'campoData', caption: 'Data Partenza', colVisible: false, dataField: 'datiTrasportoPartenzaDataInizioTrasporto', dataType: "datetime", editorType: 'dxDateBox', hideOnEdit: false,
          mask: 'dd/MM/yyyy',
          width: 18.2 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campoData', caption: 'Ora Partenza', colVisible: false, dataField: 'datiTrasportoPartenzaOraInizioTrasporto', dataType: "time", editorType: 'dxDateBox', hideOnEdit: false,
          mask: 'HH:mm',
          width: 18.2 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
  
  
        { type: 'campo', caption: 'Annotazioni', colVisible: false, dataField: 'datiTrasportoPartenzaAnnotazioni', dataType: "", hideOnEdit: false, editorType: 'dxTextArea' },
  
      ]
  
    },
  ]